// extracted by mini-css-extract-plugin
module.exports = {"collaborativeDetails":"collaborativeDetails_collaborativeDetails__2RIEr","img_content":"collaborativeDetails_img_content__3CJKR"};